var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsIllustrator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.18,
    height: 46,
    viewBox: "0 0 47.18 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skills_illustrator",
    transform: "translate(-232 -773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M8.355,0h30.47a8.348,8.348,0,0,1,8.355,8.355V37.645A8.348,8.348,0,0,1,38.825,46H8.355A8.348,8.348,0,0,1,0,37.645V8.355A8.348,8.348,0,0,1,8.355,0Z",
    transform: "translate(232 773)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M62.4,75.325H55.091L53.6,79.944a.344.344,0,0,1-.374.275h-3.7c-.216,0-.275-.118-.216-.354l6.33-18.223c.059-.2.118-.413.2-.649a6.867,6.867,0,0,0,.118-1.278.2.2,0,0,1,.157-.216h5.091c.157,0,.236.059.256.157l7.175,20.248c.059.216,0,.315-.2.315H64.331A.3.3,0,0,1,64.016,80Zm-6.173-3.991h4.993c-.118-.413-.275-.9-.452-1.415-.177-.531-.354-1.1-.531-1.691-.2-.609-.374-1.2-.57-1.809s-.374-1.179-.531-1.75c-.157-.55-.295-1.062-.432-1.533h-.039A24.135,24.135,0,0,1,58,65.673c-.295.944-.59,1.926-.9,2.909C56.821,69.585,56.527,70.509,56.232,71.334Z",
    transform: "translate(192.399 725.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M160.113,56.834a2.433,2.433,0,0,1-1.75-.688,2.554,2.554,0,0,1-.668-1.809,2.313,2.313,0,0,1,.708-1.75,2.518,2.518,0,0,1,1.75-.688,2.354,2.354,0,0,1,1.789.688,2.7,2.7,0,0,1-.039,3.558A2.312,2.312,0,0,1,160.113,56.834Zm-2.2,17.063V58.761c0-.2.079-.275.256-.275h3.892c.177,0,.256.1.256.275V73.9c0,.216-.079.315-.256.315h-3.853A.275.275,0,0,1,157.912,73.9Z",
    transform: "translate(105.305 731.303)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsIllustrator);
export default __webpack_public_path__ + "static/media/skills_illustrator.6acb20b8d947c9789e77b57686e7d90b.svg";
export { ForwardRef as ReactComponent };